import React, { createContext, useCallback, useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const SummaryContext = createContext({
  showSummary: false,
  setShowSummary: (_: boolean) => {}
});

const SummaryContextProvider: React.FC<React.PropsWithChildren<{}>> = ({
  children
}) => {
  const [showSummary, setShowSummary] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get('summary') === 'open') {
      setShowSummary(true);
    } else {
      setShowSummary(false);
    }
  }, [location.search]);

  const handleSetShowSummary = useCallback((value: boolean) => {
    if (value === showSummary) {
      return
    }
    setShowSummary(value);
    const params = new URLSearchParams(location.search);
    if (value) {
      params.set('summary', 'open');
    } else {
      params.delete('summary');
    }
    navigate({ search: params.toString() });
  }, [showSummary, setShowSummary, navigate, location.search]);

  return (
    <SummaryContext.Provider
      value={{ showSummary, setShowSummary: handleSetShowSummary }}
    >
      {children}
    </SummaryContext.Provider>
  );
};

export default SummaryContext;
export { SummaryContextProvider };
